import { Component, componentMixin } from '@resn/gozer-core/component';
import DomComponentMixin from '@resn/gozer-core-mixins/dom-component';
import { html } from '@resn/gozer-core';
import { isIOS, isAndroid } from '@resn/gozer-env';
import env from 'core/env';
import BtnMain from 'component/btn-main';
import { COLORS } from 'core/constants';
import { autobind } from 'core-decorators';
import MaterialPicker from '../common/material-picker';
import SectionMixin from 'component/sections/base/section-mixin';
import SectionFallbackMixin from 'component/sections/base/section-fallback-mixin';
import { deviceBenchmark } from 'utils/device-benchmark';
import MaterialImage from '../common/material-image';
import { isMobile } from '@resn/gozer-env';
import './index.scss';
import svg from 'component/svg';
import Copy from '@resn/gozer-core/copy';

const baseUrl = __ENV__ === 'local' ? `${window.location.origin + '/'}` : __URL__;

const template = ({ props }) => html`<section
    class="arStandalone ${window.__STANDALONE__ ? 'arStandalone--std' : ''} inverseColors"
    align="right"
>
    ${window.__STANDALONE__
        ? html`<div class="arStandalone__header homeHeader">
              ${svg('oxefit-logo-full-color', 'arStandalone__logo')}<a href=${baseUrl}>
                  <button class="arStandalone__homeBtn text-mainBtn">HOME</button></a
              >
          </div>`
        : html``}
    <div class="simpleContent__inner grid maxWidth" data-ui="inner">
        ${isMobile
            ? html`<div class="arStandalone__content simpleContent__content" data-ui="content">
                  ${!window.__STANDALONE__
                      ? html`<h3 class="arStandalone__pretitle text-heading9">
                            ${Copy.get('xs1-product-module-6-mobile-title')}
                        </h3>`
                      : html``}
                  <h1 class="arStandalone__title text-heading3">${Copy.get('xs1-product-module-6-mobile-pretitle')}</h1>
              </div>`
            : html``}
        <div class="arStandalone__imageMaterialWrap" data-ui="imageWrap">
            ${isIOS
                ? html`<a rel="ar" class="arStandalone__arLink" data-ui="link" href=${props.srcModelIos}
                      ><img
                          src="${env.CDN}static/images/pages/xs1/machine/transparent.png"
                          alt=""
                          class="arStandalone__imagePlaceholder"
                  /></a> `
                : isAndroid
                ? html`<a class="arStandalone__arLink" data-ui="link" href=${props.srcModelAndroid}></a>`
                : html``}
        </div>
        <div class="arStandalone__content" data-ui="content">
            ${!isMobile
                ? html`
                      <h3 class="arStandalone__pretitle text-heading9">
                          ${Copy.get('xs1-product-module-6-mobile-title')}
                      </h3>
                      <h1 class="arStandalone__title text-heading3">
                          ${Copy.get('xs1-product-module-6-mobile-pretitle')}
                      </h1>
                  `
                : html``}
            <div class="arStandalone__matPickerWrapper" data-ui="pickerWrapper"></div>
            <div class="arStandalone__btnARWrap" data-ui="btnWrap"></div>
        </div>
    </div>
</section>`;

const versionNames = ['black', 'grey', 'rose'];

import usdzBlack from 'public/static/ar/xs1-machine-ar-black-scene.usdz';
import usdzGrey from 'public/static/ar/xs1-machine-ar-grey-scene.usdz';
import usdzRose from 'public/static/ar/xs1-machine-ar-rose-scene.usdz';

const usdzFiles = [usdzBlack, usdzGrey, usdzRose];

@componentMixin(DomComponentMixin)
@componentMixin(deviceBenchmark.fallback ? SectionFallbackMixin : SectionMixin)
class XS1ARStandalone extends Component {
    options = {
        template,
    };

    props = {
        version: 1,
        srcModelIos: (props) => `${usdzFiles[props.version - 1]}`,
        srcModelAndroid: (props) =>
            `intent://arvr.google.com/scene-viewer/1.1?file=${baseUrl}static/gltf/xs1/xs1-machine-ar-${
                versionNames[props.version - 1]
            }.glb&mode=ar_preferred#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=https://developers.google.com/ar;end;`,
    };

    async onSetup() {
        this.btnExplore = await new BtnMain().setup({
            options: {
                appendTo: this.ui.btnWrap,
                onClick: this.onButtonARClick,
            },
            props: {
                text: () => Copy.get(`xs1-product-module-6-mobile-cta-${this.props.version}`),
                textColor: '#ffffff',
                bgColor: COLORS.ELECTRIC_BLUE,
            },
        });

        this.materialPicker = await new MaterialPicker().setup({
            options: {
                appendTo: this.ui['pickerWrapper'],
                handlerIndexChange: this.onMaterialIndexChange,

                cCursor: COLORS.ELECTRIC_BLUE,
                borderWidthCursor: 2,
            },
            props: {
                active: true,
                itemSize: 130,
            },
        });

        this.materialImages = await Promise.all(
            Array.from(new Array(3)).map(async (_, i) => {
                return await new MaterialImage().setup({
                    options: {
                        appendTo: this.ui.imageWrap,
                        src: {
                            desktop: `${env.CDN}static/images/pages/xs1/intro/intro-colours-${i + 1}.png`,
                            mobile: `${env.CDN}static/images/pages/xs1/intro/mobile/intro-colours-${i + 1}.png`,
                        },
                        classNameParent: 'arStandalone',
                    },
                    props: {
                        active: () => this.props.version == i + 1,
                    },
                });
            }),
        );
    }

    @autobind
    onMaterialIndexChange(i) {
        this.props.version = i + 1;
    }

    @autobind
    onButtonARClick() {
        this.ui.link.click();
    }
}

export default XS1ARStandalone;
